










































import { Vue, Component, Prop } from 'nuxt-property-decorator'
import { defineComponent } from '@nuxtjs/composition-api'
import InputCheckbox from '@/components/Inputs/InputCheckbox.vue'
import Link from '@/components/Link.vue'
import { FormInputCheckbox } from '@/contracts/FormInput'

type LinkType = {
  label: string
  url: string
}

@Component
class InputAccept extends Vue implements FormInputCheckbox {
  @Prop({ default: '' }) readonly error: string = ''
  @Prop({ default: '' }) readonly privacyTitle: string = ''
  @Prop({ default: '' }) readonly privacyLinkUrl: string = ''
  @Prop({ default: '' }) readonly privacyLinkLabel: string = ''
  @Prop({ default: '' }) readonly dynamicContent: string = ''
  @Prop({ default: false }) readonly value: boolean = false
  @Prop({ default: false }) readonly isNewStyle: boolean = false
  @Prop({ default: '' }) readonly privacyAfterLinkText: string = ''
  @Prop() readonly link: LinkType = { url: '', label: '' }
  @Prop() readonly title: string = ''
  @Prop() readonly disabled: boolean = false
  static options: any
}

export default defineComponent({
  name: 'InputAccept',
  components: {
    InputCheckbox,
    Link,
  },
  props: InputAccept.options.props,
})
